module.exports = __webpack_public_path__ + "static/img/5.d99e9f15.jpg";